import ColumnsContent from 'components/Hocs/ColumnsContent';
import ContentMain from './FinishedCompetitions';

export default ColumnsContent(ContentMain);



// WEBPACK FOOTER //
// ./src/lauoyts/LayoutApp/Content/Competitions/FinishedCompetitions/index.js